<template>
  <v-card flat outlined style="border-left: 2px solid var(--v-info-base)">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-subtitle>{{ baseText }}</v-list-item-subtitle>
        <v-list-item-title class="headline mb-1 font-weight-bold" style="font-family: inherit !important;">
          <h3>{{ baseValue }}</h3>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  props: ["baseValue", "baseText"],
};
</script>
